// Cuentas: registro, sesion, quien soy, familia.
//
// Vivia en `lib/api.js` junto con otros veintidos apartados (R4.5). Quien lo importa
// no se entero: `@/lib/api` sigue exportando exactamente lo mismo.
import { api } from "./client";

// ---- Auth ----

// EL AÑO Y EL MES VIAJAN, PERO NO SE GUARDAN. El servidor calcula si tiene catorce y se
// queda solo con el sí o el no; los dos números no llegan a escribirse en ninguna parte. El
// porqué entero está en `backend/app/domain/edad.py`.
export const registerUser = async ({ email, name, password, apellidos, etapa, anio, mes, emailTutor }) => {
  const { data } = await api.post("/auth/register", {
    email, name, password, apellidos, etapa,
    anio_nacimiento: anio, mes_nacimiento: mes,
    email_tutor: emailTutor || null,
  });
  return data;
};

// Quién eres y en qué curso estás. Para las cuentas que no pasaron por el registro: las que
// crea el profesor pegando la lista de su clase, que en septiembre son la mayoría.
export const guardaFicha = async (name, apellidos, etapa) => {
  const { data } = await api.post("/auth/ficha", { name, apellidos, etapa });
  return data;
};

// LOS DOS AJUSTES QUE NO PUEDEN VIVIR EN EL NAVEGADOR. El resto de preferencias están en
// `localStorage` —quien necesita más contraste lo necesita antes de tener sesión— pero estos los
// aplica el servidor: si «no salir en la Liga» viviera en el navegador, bastaría con entrar
// desde el móvil para volver a aparecer, y eso es una promesa de privacidad que se rompe sola.
//
// Se manda SOLO lo que se cambia: lo que no viaja, no se toca.
export const guardaAjustesDeCuenta = async (cambios) => {
  const { data } = await api.post("/auth/ajustes", cambios);
  return data;
};

// Para las cuentas que existen desde antes de que esto se preguntara.
export const declaraEdad = async (anio, mes) => {
  const { data } = await api.post("/auth/edad", { anio_nacimiento: anio, mes_nacimiento: mes });
  return data;
};

// Pide el permiso, o lo vuelve a pedir con otro correo. Corregir un correo mal tecleado es
// la razón más común por la que un permiso no llega nunca.
export const pidePermisoTutor = async (email) => {
  const { data } = await api.post("/auth/tutor", { email });
  return data;
};

// La pulsa el tutor desde su correo: no hay sesión, solo el token del enlace.
export const confirmaTutor = async (t) => {
  const { data } = await api.get("/auth/tutor/confirmar", { params: { t } });
  return data;
};

// AQUI SE GUARDABA EL TOKEN EN `localStorage`, Y YA NO. La sesion vive SOLO en la cookie
// `httponly`, que el JavaScript de la pagina no puede leer: un XSS ya no se la lleva. El
// token de aqui era el que si podia leer, y ademas resulto que era el unico que funcionaba
// —el navegador tiraba la cookie porque `axios` no pedia credenciales— asi que quitarlo antes
// del 2 de septiembre habria dejado fuera a todo el mundo. Comprobado en produccion antes de
// tocarlo: borrando la llave y recargando, la sesion aguanta. Lo vigila `tools/check_sesion.py`.
export const loginUser = async ({ email, password }) => {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
};

export const logoutUser = async () => {
  try {
    await api.post("/auth/logout");
  } catch {}
};

export const fetchMe = async () => {
  const { data } = await api.get("/auth/me");
  return data;
};

// La contrasena de una cuenta de aula nace en un papel que ha dado la vuelta a la clase,
// asi que la primera que pone el alumno es la primera de verdad. El backend apaga el aviso.
//
// `actual` va vacia SOLO en ese primer acceso, donde pedirla no comprobaria nada: la sabe
// quien repartio el papel. En cualquier otro momento el servidor la exige, porque si no una
// sesion abierta en el ordenador del aula es la cuenta entera para el siguiente que se siente.
export const cambiarClave = async (clave, actual = "") => {
  const { data } = await api.post("/auth/cambiar-clave", { clave, actual });
  return data;
};

// «¿Has olvidado tu contraseña?». Las dos van sin sesión: quien llega aquí no puede entrar.
// La primera contesta LO MISMO exista o no la cuenta; la segunda usa el enlace del correo, que
// vale una hora y una sola vez. El porqué, en `backend/app/domain/clave_olvidada.py`.
export const pideEnlaceDeClave = async (email) => {
  const { data } = await api.post("/auth/clave-olvidada", { email });
  return data;
};

export const ponClaveNueva = async (t, clave) => {
  const { data } = await api.post("/auth/clave-nueva", { t, clave });
  return data;
};

// ---- Los dos derechos ----
// Ninguna de las dos lleva un identificador de usuario: se contestan a quien pregunta, con la
// sesión que ya viaja en la cookie. Una exportación con un `user_id` en la URL sería la misma
// fuga que se tapó en el Test Alpha, pero con todo dentro en vez de con un correo.

export const misDatos = async () => {
  const { data } = await api.get("/auth/mis-datos");
  return data;
};

// `delete` con cuerpo: axios lo manda en `data`, no como segundo argumento. Escrito así a
// propósito, porque el que se equivoca manda `{clave, confirmacion}` como configuración de
// axios, el servidor recibe un cuerpo vacío y contesta un 422 que no dice nada de esto.
export const borrarCuenta = async (clave, confirmacion) => {
  const { data } = await api.delete("/auth/cuenta", { data: { clave, confirmacion } });
  return data;
};

// ---- Apodo ----
// El nombre que ven los demas. El backend valida: aqui NO se repite la comprobacion, que
// seria una segunda regla capaz de decir que si a lo que la de verdad dice que no.

export const cambiarApodo = async (apodo) => {
  const { data } = await api.put("/auth/apodo", { apodo });
  return data;
};

export const sugerenciasApodo = async () => {
  const { data } = await api.get("/auth/apodo/sugerencias");
  return data?.apodos ?? [];
};

export const getPricingPlans = async () => {
  const { data } = await api.get("/pricing/plans");
  return data;
};
